import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Records";
import getToken from "app/api/getToken";
import { IRecordRequest } from "app/api/types";

export const ADD_RECORD_REQUEST = "ADD_RECORD_REQUEST";
export const ADD_RECORD_SUCCESS = "ADD_RECORD_SUCCESS";
export const ADD_RECORD_FAIL = "ADD_RECORD_FAIL";

export const addRecord = (data: IRecordRequest) => (dispatch: any): any => {
  dispatch({ type: ADD_RECORD_REQUEST });

  const token = getToken();

  return api
    .addRecord(token, data)
    .then((response: AxiosResponse) => {
      const master: IRecordRequest = get(response, "data", {});
      dispatch({ type: ADD_RECORD_SUCCESS, payload: master });

      return master;
    })
    .catch(err => {
      dispatch({
        type: ADD_RECORD_FAIL,
        payload: get(err, "response.data.errors", {})
      });
      throw get(err, "response.data.errors", {});
    });
};
